import { Controller } from "@hotwired/stimulus";

// Checking the exclusive checkbox clears the others, and checking any other clears it
export default class extends Controller {
  static targets = ["checkbox", "exclusive"]

  checkExclusive() {
    if (!this.exclusiveTarget.checked) return;

    this.checkboxTargets.forEach(checkbox => { checkbox.checked = false; });
  }

  checkOther(event) {
    if (event.target.checked) this.exclusiveTarget.checked = false;
  }
}
